import * as Component from 'src/feature/bite/component'
import * as Yup from 'yup'
import {useIntl} from 'react-intl'
import {Field, Form, Formik} from 'formik'
import {useUpdateVIPTier, useChangeStatusCampaign} from '../context/useMutation'
import {useVIP} from '../hook'
import {useGetDetail, useGetProgramDetail, useGetVIPCampaignList} from '../context/useQuery'
import {useNavigate, useLocation} from 'react-router-dom'
import {useEffect, useState} from 'react'
import {Dropdown} from 'react-bootstrap'

import RefModal from './components/Modal'
import {NumericFormat} from 'react-number-format'

function EditVipTier() {
  useGetProgramDetail()
  const navigate = useNavigate()
  const location = useLocation()
  const [isModalOpen, setIsModalOpen] = useState(false)
  /* const [deleteId, setDeleteId] = useState(null) */

  const {program, detail, VIPCampaignList} = useVIP()

  const {isLoading} = useGetDetail()
  const {isLoading: isLoadingCampaign, refetch: campaignListRefetch} = useGetVIPCampaignList()

  const {mutateAsync, isLoading: vipIsLoading} = useUpdateVIPTier()
  /* const { mutateAsync: deleteCampaignMutate, isLoading: vipIsDeleteLoading } = useDeleteVIPCampaign() */
  const {mutateAsync: changeCampaignStatusMutate, isLoading: changeStatusLoading} =
    useChangeStatusCampaign()

  const intl = useIntl()

  const onSubmit = async (values: any, {setSubmitting, resetForm}: any) => {
    if (vipIsLoading) return

    if (values.icon === '') values.icon = 'icon.png'
    await mutateAsync({values})
    setSubmitting(false)
  }

  const validSchema = Yup.object({
    name: Yup.string()
      .required(intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'}))
      .max(50, intl.formatMessage({id: 'GLOBAL.ERROR.MAX_LIMIT_INPUT'}, {length: 50})),
    value: Yup.number()
      .min(1, intl.formatMessage({id: 'GLOBAL.ERROR.MIN_LIMIT_INPUT'}, {length: 1}))
      .max(999999.99, intl.formatMessage({id: 'GLOBAL.ERROR.MAX_LIMIT_INPUT'}, {length: 999999.99}))
      .required(intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'})),
    icon: Yup.string(),
    status: Yup.number(),
  })

  useEffect(() => {
    // search for campaignId in url
    const search = new URLSearchParams(location.search)
    const campaignId = search.get('campaignId')
    if (campaignId) {
      setIsModalOpen(true)
    }
  }, [detail])

  return (
    <>
      <div className='d-flex gap-5 align-items-center'>
        <button
          className='btn btn-primary btn-sm btn-back'
          onClick={() => {
            navigate('/vip')
          }}
        >
          <i className='fa fa-arrow-left '></i>
        </button>
        <Component.Breadcrumb currentPage={detail?.name || 'Update Tier'} parentPage='VIP Tiers' />
      </div>
      {isLoading ? (
        <div
          style={{
            top: 0,
            left: 0,
            height: '100%',
            width: '100%',
            zIndex: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'absolute',
            background: 'rgb(255 255 255 / 76%)',
          }}
        >
          {intl.formatMessage({id: 'LOADING'})}...
        </div>
      ) : (
        <Formik
          initialValues={{
            name: detail?.name || '',
            value: detail?.value || '',
            icon: detail?.icon || '',
            status: detail?.status || 1,
            customerCount: detail?.customerCount || 0,
            id: detail?.id || '',
          }}
          validationSchema={validSchema}
          enableReinitialize
          onSubmit={onSubmit}
        >
          {({values, errors, touched, setFieldValue, setFieldTouched}) => {
            const anyChange = values.name !== detail?.name || values.value !== detail?.value

            return (
              <Form className='form d-flex flex-column flex-lg-row fv-plugins-bootstrap5 fv-plugins-framework w-100'>
                <div className='row  mt-10 w-100'>
                  <div className='col-md-9'>
                    <div className='card'>
                      <div className='card-header border-0'>
                        <div className='card-title d-flex flex-column'>
                          <div className='d-flex align-items-center position-relative my-1 fs-2 fw-bold'>
                            {intl.formatMessage({id: 'VIP.UPDATE.TIER'})}
                          </div>
                        </div>
                      </div>

                      <div className='card-body'>
                        <div className='row'>
                          <div className='col-md-12'>
                            <div className='form-group mb-5 w-50'>
                              <label className='form-label fw-bold'>
                                {intl.formatMessage({id: 'VIP.TIER.NAME'})}
                              </label>
                              <p className=' fs-6'>
                                {intl.formatMessage({id: 'VIP.TIER.NAME.DESC'})}
                              </p>
                              <Field
                                type='text'
                                name='name'
                                className='form-control'
                                placeholder='e.g. Champions'
                                maxLength={51}
                              />
                              {errors.name && touched.name && (
                                <div className='fv-plugins-message-container'>
                                  <div className='fv-help-block'>{errors?.name}</div>
                                </div>
                              )}
                            </div>
                          </div>
                          <div className='col-md-12'>
                            <div className='form-group mb-5 w-50'>
                              <label className='form-label fw-bold'>
                                {intl.formatMessage({id: 'VIP.TIER.REQUIREMENT'})}
                              </label>
                              <p className=' fs-6'>
                                {program?.entryMethodType === 1
                                  ? intl.formatMessage({id: 'VIP.TIER.REQUIREMENT.POINT'})
                                  : program?.entryMethodType === 2
                                  ? intl.formatMessage({id: 'VIP.TIER.REQUIREMENT.SPENT'})
                                  : intl.formatMessage({id: 'VIP.TIER.REQUIREMENT.ORDER'})}
                              </p>
                              <NumericFormat
                                name='value'
                                className='form-control'
                                placeholder='e.g. 250'
                                maxLength={10}
                                allowLeadingZeros={false}
                                allowNegative={false}
                                decimalScale={0}
                                value={values.value}
                                onValueChange={(values) => {
                                  setFieldValue('value', values.floatValue)
                                }}
                                onBlur={() => {
                                  setFieldTouched('value', true)
                                }}
                              />
                              {errors.value && touched.value && (
                                <div className='fv-plugins-message-container'>
                                  <div className='fv-help-block'>{errors.value}</div>
                                </div>
                              )}
                              {/*  <span className=' fs-8'>
                                {program?.entryMethodType === 1
                                  ? intl.formatMessage(
                                    { id: 'VIP.TIER.INFO.POINT' },
                                    { point: values.value }
                                  )
                                  : program?.entryMethodType === 2
                                    ? intl.formatMessage(
                                      { id: 'VIP.TIER.INFO.SPENT' },
                                      { point: values.value }
                                    )
                                    : intl.formatMessage(
                                      { id: 'VIP.TIER.INFO.ORDER' },
                                      { point: values.value }
                                    )}
                              </span> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='card mt-10'>
                      <div className='card-header border-0'>
                        <div className='card-title d-flex flex-column'>
                          <div className='d-flex align-items-center position-relative my-1 fs-2 fw-bold'>
                            {intl.formatMessage({id: 'VIP.TIER.REWARD.SUMMARY.2'})}
                          </div>
                          <p className='fs-6'>
                            {intl.formatMessage(
                              {id: 'VIP.TIER.REWARD.SUMMARY.DESC.1'},
                              {tier: values.name}
                            )}
                            {/* {program?.entryMethodType === 1
                              ? intl.formatMessage(
                                { id: 'VIP.TIER.REWARD.SUMMARY.DESC.POINT' },
                                { point: values.value }
                              )
                              : program?.entryMethodType === 2
                                ? intl.formatMessage(
                                  { id: 'VIP.TIER.REWARD.SUMMARY.DESC.SPENT' },
                                  { point: values.value }
                                )
                                : intl.formatMessage(
                                  { id: 'VIP.TIER.REWARD.SUMMARY.DESC.ORDER' },
                                  { point: values.value }
                                )} */}
                          </p>
                        </div>
                      </div>
                      <div className='card-body mt-5 pt-0'>
                        <div className='form-check form-switch form-check-custom form-check-solid'>
                          <span
                            className='btn btn-primary'
                            onClick={() => {
                              // setIsCampaignAddRewardModalOpen(true)
                              setIsModalOpen(true)
                            }}
                          >
                            {intl.formatMessage({id: 'VIP.ADD.REWARD'})}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className='card mt-10'>
                      <div className='card-header border-0'>
                        <div className='card-title d-flex flex-column'>
                          <div className='d-flex align-items-center position-relative my-1 fs-2 fw-bold'>
                            {intl.formatMessage({id: 'VIP.CAMPAIGN.LIST'})}
                          </div>
                        </div>
                      </div>
                      <div className='card-body mt-5 pt-0'>
                        <div className='form-check form-switch form-check-custom form-check-solid'>
                          {isLoadingCampaign ? (
                            <div
                              style={{
                                top: 0,
                                left: 0,
                                height: '100%',
                                width: '100%',
                                zIndex: 1,
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                position: 'absolute',
                                background: 'rgb(255 255 255 / 76%)',
                              }}
                            >
                              {intl.formatMessage({id: 'LOADING'})}...
                            </div>
                          ) : (
                            <table className='table align-middle table-row-dashed table-striped fs-6 gy-5'>
                              <tbody>
                                {VIPCampaignList?.data.map((item: any, index: number) => (
                                  <tr key={index}>
                                    <td>
                                      <span className='fw-bold me-5'>{item.campaignName}</span>
                                      {item.status === 1 ? (
                                        <span className='bg-success text-white px-2 py-1 rounded'>
                                          {intl.formatMessage({id: 'GLOBAL.ACTIVE'})}
                                        </span>
                                      ) : (
                                        <span className='bg-light text-dark px-2 py-1 rounded'>
                                          {intl.formatMessage({id: 'GLOBAL.INACTIVE'})}
                                        </span>
                                      )}
                                    </td>
                                    <td className='text-end d-flex justify-content-center gap-5'>
                                      <div className='position-relative'>
                                        <Dropdown>
                                          <Dropdown.Toggle variant='link'>
                                            {intl.formatMessage({id: 'GLOBAL.BUTTON.ACTION'})}
                                          </Dropdown.Toggle>

                                          <Dropdown.Menu>
                                            <Dropdown.Item
                                              disabled={changeStatusLoading || item.status === 1}
                                              onClick={async () => {
                                                await changeCampaignStatusMutate({
                                                  campaignID: item.campaignID,
                                                  status: 1,
                                                })
                                                campaignListRefetch()
                                              }}
                                            >
                                              {intl.formatMessage({id: 'GLOBAL.BUTTON.ACTIVATE'})}
                                            </Dropdown.Item>
                                            <Dropdown.Item
                                              disabled={changeStatusLoading || item.status === 2}
                                              onClick={async () => {
                                                await changeCampaignStatusMutate({
                                                  campaignID: item.campaignID,
                                                  status: 2,
                                                })
                                                campaignListRefetch()
                                              }}
                                            >
                                              {intl.formatMessage({id: 'GLOBAL.BUTTON.DEACTIVATE'})}
                                            </Dropdown.Item>
                                            {/* <Dropdown.Item
                                              style={{ color: 'red' }}
                                              disabled={vipIsDeleteLoading}
                                              onClick={() => {
                                                setDeleteId(item.campaignID)
                                              }}
                                            >
                                              {intl.formatMessage({ id: 'GLOBAL.BUTTON.DELETE' })}
                                            </Dropdown.Item> */}
                                            <Dropdown.Item
                                              disabled={changeStatusLoading}
                                              onClick={() => {
                                                const currentId = location.pathname.split('/').pop()
                                                navigate(
                                                  `/vip/edit/${currentId}?campaignId=${item.campaignID}`
                                                )
                                                setIsModalOpen(true)
                                              }}
                                            >
                                              {intl.formatMessage({id: 'GLOBAL.BUTTON.VIEW'})}
                                            </Dropdown.Item>
                                          </Dropdown.Menu>
                                        </Dropdown>
                                      </div>
                                    </td>
                                  </tr>
                                ))}

                                {VIPCampaignList?.data.length === 0 && (
                                  <tr>
                                    <td colSpan={2}>{intl.formatMessage({id: 'NOT_FOUND'})}</td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col-md-3'>
                    <div className='card'>
                      <div className='card-header border-0'>
                        <div className='card-title d-flex flex-column'>
                          <div className='d-flex align-items-center position-relative fs-4 fw-bold'>
                            {/* Reward Summary */}
                            {intl.formatMessage({id: 'VIP.TIER.REWARD.SUMMARY.EDIT'})}
                          </div>
                        </div>
                      </div>
                      <div className='card-body mt-0 pt-0'>
                        <li className='list-group-item d-flex align-items-center'>
                          <i className='bi bi-dot fs-2 text-primary'></i>
                          <span className='fs-6'>
                            {/* You haven’t unlocked any rewards yet. */}
                            {values.name || intl.formatMessage({id: 'VIP.TIER.NAME'})}
                          </span>
                        </li>
                        <li className='list-group-item d-flex align-items-center'>
                          <i className='bi bi-dot fs-2 text-primary'></i>
                          <span className='fs-6'>
                            {/* {detail?.value || 250} points earned since the start date. */}

                            {program?.entryMethodType === 1
                              ? intl.formatMessage(
                                  {id: 'VIP.TIER.REWARD.SUMMARY.DESC.POINT'},
                                  {point: values.value}
                                )
                              : program?.entryMethodType === 2
                              ? intl.formatMessage(
                                  {id: 'VIP.TIER.REWARD.SUMMARY.DESC.SPENT'},
                                  {point: values.value}
                                )
                              : intl.formatMessage(
                                  {id: 'VIP.TIER.REWARD.SUMMARY.DESC.ORDER'},
                                  {point: values.value}
                                )}
                          </span>
                        </li>
                        {VIPCampaignList?.data.length === 0 && (
                          <li className='list-group-item d-flex align-items-center'>
                            <i className='bi bi-dot fs-2 text-primary'></i>
                            <span className='fs-6'>
                              {/* You haven’t unlocked any rewards yet. */}
                              {intl.formatMessage({id: 'VIP.TIER.REWARD.SUMMARY.DESC.2'})}
                            </span>
                          </li>
                        )}
                      </div>
                    </div>
                    <button
                      type='submit'
                      className='btn btn-primary mt-10 w-100'
                      disabled={program?.processing || vipIsLoading || !anyChange}
                    >
                      {vipIsLoading ? (
                        <span className='indicator-label'>
                          {intl.formatMessage({id: 'PLEASE_WAIT'})}{' '}
                          <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                        </span>
                      ) : (
                        <span className='indicator-label'>
                          {intl.formatMessage({id: 'GLOBAL.BUTTON.UPDATE'})}
                        </span>
                      )}
                    </button>
                  </div>
                </div>
              </Form>
            )
          }}
        </Formik>
      )}

      {isModalOpen && (
        <RefModal
          isOpen={isModalOpen}
          // onClose={setIsModalOpen}
          onClose={(value: boolean) => {
            const currentId = location.pathname.split('/').pop()
            navigate(`/vip/edit/${currentId}`)
            setIsModalOpen(value)
          }}
          refetch={campaignListRefetch}
          tierID={detail?.id}
        />
      )}
    </>
  )
}

export default EditVipTier
